import { AbTestCampaignNameEnum } from '@models/ab-test-models';
import { createReducer, on } from '@ngrx/store';
import { initABTestCampaignsSuccess } from '@stores/abtest/abtest-ngrx.action';

export const abtestKey = 'abtest';

export const abTestReducer = createReducer(
  {},
  on(initABTestCampaignsSuccess, (_, { abtestValues }) => {
    return {
      [AbTestCampaignNameEnum.NewUserJourney]: { variant: abtestValues[AbTestCampaignNameEnum.NewUserJourney].value },
    };
  })
);
